import $ from 'jquery';
import 'owl.carousel';

class Hero {
  constructor() {
    this.heroCarousel = $('.js-hero-carousel');
    this.speed = 1000;

    this.carousel();
  }

  carousel() {
    if (!this.heroCarousel.length) {
      return;
    }

    $.each(this.heroCarousel, (i, el) => {
      const carousel = $(el);

      const isAutoplay = carousel.data('hc-autoplay') === 'yes';
      const isLoop = carousel.data('hc-loop') === 'yes';
      const timeout = carousel.data('hc-timeout') * 1000;
      const animation = carousel.data('hc-animation') || 'slide';

      const params = {
        dots: false,
        nav: true,
        navText: [
          '<svg class="c-icon c-icon--arrow-left"><use xlink:href="#c-icon--arrow-left"></use></svg>',
          '<svg class="c-icon c-icon--arrow-right"><use xlink:href="#c-icon--arrow-right"></use></svg>',
        ],
        mouseDrag: true,
        touchDrag: true,
        navSpeed: this.speed,
        dotsSpeed: this.speed,
        dragEndSpeed: this.speed,
        loop: isLoop,
        autoplay: isAutoplay,
        autoplaySpeed: this.speed,
        autoplayTimeout: timeout,
        autoplayHoverPause: true,
        margin: 0,
        items: 1,
        autoHeight: true,
      };

      // if (animation === 'fade') {
      //   params.animateOut = 'fadeOut';
      //   params.animateIn = 'fadeIn';
      // }

      carousel.on('initialized.owl.carousel', () => {
        setTimeout(() => {
          Hero.textBoxToggle(carousel, 'show');
        });
      });

      carousel.owlCarousel(params);

      carousel.on('translate.owl.carousel', () => {
        if (animation === 'slide') {
          Hero.textBoxToggle(carousel, 'hide');
        }
      });

      carousel.on('translated.owl.carousel', () => {
        if (animation === 'slide') {
          Hero.textBoxToggle(carousel, 'show');
        }
      });
    });
  }

  static textBoxToggle(carousel, state) {
    const textBox = carousel.find('.js-hero-text-box');

    if (textBox.length) {
      if (state === 'show') {
        textBox
          .stop()
          .css({ visibility: 'visible' })
          .animate(
            {
              opacity: 1,
            },
            500,
          );
      } else {
        textBox.stop().animate(
          {
            opacity: 0,
          },
          200,
          () => {
            textBox.css({ visibility: 'hidden' });
          },
        );
      }
    }
  }
}

export default new Hero();



// WEBPACK FOOTER //
// ./src/scripts/modules/hero.js